module.exports = __webpack_public_path__ + "static/media/lactose_free.f8247c08.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/lactose_free.svg
// module id = 148
// module chunks = 0